
import {
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Stack,
} from '@mui/material';
import QuestionFileUpload from '../../QuestionFileUpload';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const RadioQuestion = ({ q, sectionIndex, handleChange, error, formData, setFormData, isDisabled, handleFiles }) => {
  const { t } = useTranslation()
  const [answers, setAnswers] = useState((q.answers || []))

  return (
    <Box>
      <RadioGroup
        value={answers?.[0]}
        onChange={(e) => {
          if (handleChange) {
            const value = e.target.value;
            handleChange(sectionIndex, q, [value]);
            setAnswers([value])
          }
        }}
      >
        <Stack spacing={0.5}>
          {q.options.map((opt, i) => (
            <FormControlLabel
              key={opt?.id}
              value={opt?.id || `${opt.option}_${i}`}
              control={<Radio />}
              label={opt.option || t("questionnaire.form.optionWithNo", { number: i + 1 })}
            />
          ))}
        </Stack>
      </RadioGroup>

      <QuestionFileUpload q={q} sectionIndex={sectionIndex} isDisabled={isDisabled} handleFiles={handleFiles} />

      {error && (
        <Typography color="error" sx={{ mt: 1 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default RadioQuestion;
